import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoryPageComponent } from './story-page.component';
import { MarkdownComponent } from './markdown/markdown.component';
import { SharedModule } from '../../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { StoryTitleModule } from '../../../../shared/components/story-title/story-title.module';

const PIPES = []!;

const ANGULAR_MATERIAL_MODULES = [
  MatIconModule, MatButtonModule, MatChipsModule,
  MatFormFieldModule, MatInputModule
];

const CORE_MODULES = [CommonModule, RouterModule];

const COMPONENTS = [StoryPageComponent, MarkdownComponent];

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [
    ...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES, SharedModule,
    ReactiveFormsModule, StoryTitleModule
  ],
  exports: [...COMPONENTS]
})
export class StoryPageModule { }
